var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"mask":"###,###,###,###,###","placeholder":_vm.placeholder,"disabled":_vm.disabled},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})
}
var staticRenderFns = []

export { render, staticRenderFns }